import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div.attrs(() => ({
    className: '!flex !justify-between !items-center',
}))`
    padding: 1rem 0 0.8rem;
    margin-bottom: 0.8rem;
    border-bottom: 1px solid #fff;

    > * {
        margin: 0;
    }

    .heading {
        font-size: 1.6rem;
        font-weight: 200;
        color: ${props => props.theme.admin.colors.brand};
    }
`

const Heading = ({ name = 'Set heading', children }) => {
    return (
        <Wrapper>
            <h1 className="heading" data-testid="page-heading">
                {name}
            </h1>
            {children}
        </Wrapper>
    )
}

export default Heading
